import Box from '@mui/material/Box'
import { Button, Checkbox, FormControlLabel, Grid, List, TextField } from '@mui/material';
import * as React from 'react'
import { useFormik } from 'formik'
import {
  masterRoleByIdPrivilegesApi,
  masterRolePutApi,
} from '../../../api/master/masterAPI'
import { useEffect } from 'react'
import jwt_decode from 'jwt-decode'
import SkeletonTableLoader from '../../../common/components/loaders/skeletonLoader'
import LoadingSection from '../../../common/components/loaders/loader'

import { useLocation, useSearchParams } from 'react-router-dom'
import {
  getCompanyLevel,
  normalizeApiResponse,
  requiredLabel,
} from '../../../helpers/HelperFunctions'
import { RoleFormValidation } from '../../../validations/UserManagementValidation'
import { useToastContext } from '../../../App'
import { useCommonRedux } from '../../../store/middlewares/CommonRedux';
import { COMPANY_LEVELS, SERVICE_MANAGEMENT_CREATE_SERVICE_ID } from '../../../helpers/Constants';
// const allManagements = [];
export function EditRole(props) {
  const { dispatch, state: commonState } = useCommonRedux();
  const { toast } = useToastContext();
  const [loader, setLoader] = React.useState(false)
  const [submitLoader, setSubmitLoader] = React.useState(false)
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const [allManagement, setAllManagement] = React.useState([])
  const formik = useFormik({
    initialValues: {
      id: props?.details?.roleId,
      roleName: props?.details?.roleName,
      companyId: props?.details?.companyId,
      description: props?.details?.description,
      isSuperAdminRole: props?.details?.isSuperAdminRole,
      roleStatus: props?.details?.roleStatus,
      privileges: props?.details?.privileges,
    },
    validationSchema: RoleFormValidation,
    onSubmit: (data) => {
      checkSPCompanyView(permissionList.privileges)
      checkResellerCompanyView(permissionList.privileges)
      checkCustomerCompanyView(permissionList.privileges)
      checkServiceSelectedBool(permissionList.privileges)
      let privileges = permissionList.privileges.map((rol) => {
        let rols = rol.privileges.map((rolChild) => {

          if (rolChild.isAssigned) {
            return rolChild.id
          }
        })
        if (rols) return rols
      })
      let concatPrivileges = privileges.join(',').split(',')
      let removeBlankArray = concatPrivileges.filter((filt) => filt)

      data.privileges = []
      data.privileges = removeBlankArray
      if(commonState.currentCompanyDetails?.companyLevel ==
        COMPANY_LEVELS.customer && !commonState.currentCompanyDetails.directCustomer){
          data.privileges = data.privileges.filter(item => item !== SERVICE_MANAGEMENT_CREATE_SERVICE_ID);
        }
      const decodeToken = localStorage.getItem('sd_cp.jwt:tkn')
      const decoded = jwt_decode(decodeToken)
      let companyId = searchParams.get('company_id')
      if (!companyId) {
        companyId = decoded?.company_id
      }
      if (removeBlankArray.length > 0) {
        if (
          (checkSPCompanyView(permissionList.privileges) &&
            checkResellerCompanyView(permissionList.privileges) &&
            checkCustomerCompanyView(permissionList.privileges) &&
            'master' == location.pathname.slice(1)) ||
          (checkSPCompanyView(permissionList.privileges) &&
            checkResellerCompanyView(permissionList.privileges) &&
            checkCustomerCompanyView(permissionList.privileges) &&
            'serviceprovider' == location.pathname.slice(1)) ||
          (checkResellerCompanyView(permissionList.privileges) &&
            checkCustomerCompanyView(permissionList.privileges) &&
            'reseller' == location.pathname.slice(1)) ||
          (checkCustomerCompanyView(permissionList.privileges) &&
            'customer' == location.pathname.slice(1))
        ) {
          if (checkServiceSelectedBool(permissionList.privileges)) {
            data.companyId = companyId
            setSubmitLoader(true)
            masterRolePutApi(
              data,
              getCompanyLevel(
                searchParams.get('company_id'),
                location.pathname.slice(1)
              )
            )
              .then((response) => {
                toast.showToast(response.data.message, 'success')
                setTimeout(() => {
                  props.gotoDrawer('view')
                  const updatedDetails = {
                    ...props.details,
                    roleName: response.data.result.roleName,
                  }
                  props.toggleDrawer(
                    'right',
                    true,
                    'view',
                    updatedDetails,
                    true
                  )
                }, 100)
                setSubmitLoader(false)
              })
              .catch((error) => {
                setSubmitLoader(false)
                toast.showToast( normalizeApiResponse(error)?.message, 'error')
              })
          }
        } else {
          toast.showToast('Company View should be selected', 'error')
        }
      } else {
        toast.showToast(
          'Minimum one permission should be selected',
          'error'
        )
      }
    },
  })

  const [permissionList, setPermissionList] = React.useState([])
  // Helper function to filter privileges based on path and company details
const filterBillingPrivileges = (privileges, path, companyDetails) => {
  let filtered = { ...privileges };

  const isAltigen = companyDetails?.isAltigenBilling;
  const isRevParent = companyDetails?.isRevParent;

  switch (path) {
    case 'master':
      // no filter
      break;
    case 'serviceprovider':
      filtered.privileges = privileges.privileges.filter((p) => {
        if (!isAltigen) return p.groupName !== 'Billing';
        return p.groupName !== 'Reseller Billing' && p.groupName !== 'Customer Billing';
      });
      break;
    case 'reseller':
      filtered.privileges = privileges.privileges.filter((p) => {
        if (isAltigen) return p.groupName !== 'Customer Billing';
        if (!isAltigen && isRevParent) return p.groupName !== 'Billing';
        return p.groupName !== 'Billing';
      });
      break;
    case 'customer':
      filtered.privileges = isAltigen ? privileges.privileges : privileges.privileges.filter((p) => !p.groupName.includes('Billing'));
      break;
    default:
      filtered.privileges = privileges.privileges.filter((p) => !p.groupName.includes('Billing'));
  }

  return filtered;
};

 const getRoleByIdPrivilegesApi = async (id) => {
  try {
    setLoader(true);

    const companyId = searchParams.get('company_id');
    const path = location.pathname.slice(1);

    const response = await masterRoleByIdPrivilegesApi(id, getCompanyLevel(companyId, path));
    const privileges = response.data.result;

    const billingFilter = filterBillingPrivileges(privileges, path, commonState.currentCompanyDetails);

    const allManagements = billingFilter.privileges.map((group) => {
      const assignedCount = group.privileges.filter((p) => p.isAssigned).length;
      return assignedCount === group.privileges.length;
    });

    setAllManagement(allManagements);
    setPermissionList(billingFilter);
  } catch (error) {
    toast.showToast(normalizeApiResponse(error)?.message, 'error');
  } finally {
    setLoader(false);
  }
};




/** Assign "view" privilege for a given company type */
function assignViewPrivileges(state, companyName, includeKey = '') {
  
  state.privileges
    .filter((group) => {
      const name = group.groupName.toLowerCase();
      return (
        name.includes(includeKey.toLowerCase()) &&
        group.groupName == companyName
      );
    })
    .forEach((group) =>
      group.privileges.forEach((priv) => {
        if (priv.value.toLowerCase().includes('view')) priv.isAssigned = true;
      })
    );
}

function getAllPrivileges(state) {
  return state.privileges.flatMap(group => group.privileges);
}
function isPrivilegeMatch(value, keys) {
  const val = value.toLowerCase();
  return keys.some(k => val.includes(k));
}
function getCreateOrUpdateKeys(type) {
  return [`${type}.product.create`, `${type}.product.update`];
}
/** Handles cross-product dependencies between privilege types */
function handleProductPrivilege(state, type, viewPrivileges) {
  const createOrUpdateKeys = getCreateOrUpdateKeys(type);
  const allPrivileges = getAllPrivileges(state);

  const hasCreateOrUpdate = allPrivileges.some(priv =>
    isPrivilegeMatch(priv.value, createOrUpdateKeys)
  );

  if (hasCreateOrUpdate) {
    assignRelatedViews(state, viewPrivileges);
  }
}

/** Assigns related product views */
function assignRelatedViews(state, viewKeys) {
  const allPrivileges = getAllPrivileges(state);

  allPrivileges.forEach(priv => {
    if (isPrivilegeMatch(priv.value, viewKeys)) {
      priv.isAssigned = true;
    }
  });
}

/** Toggles privileges when select all / deselect all is clicked */
function togglePrivilegesForRole(state, isChecked, isNotEmptyRole, index) {
  if (!isNotEmptyRole) return;
  const privileges = state.privileges[index].privileges;
  privileges.forEach((obj) => (obj.isAssigned = isChecked));
  setAllManagement((prevState) =>
    prevState.map((item, i) => (i === index ? !item : item))
  );
}

const handleAllPrivileges = (e, role, index) => {
  setPermissionList((prev) => {
    const newState = { ...prev };
    const isNotEmptyRole = !!role && role.length !== 0;

    if (e.target.checked) {
      assignViewPrivileges(newState, 'ServiceProvider Company', 'serviceprovider');
      assignViewPrivileges(newState, 'Reseller Company', 'reseller');
      assignViewPrivileges(newState, 'Customer Company', 'customer');

      handleProductPrivilege(newState, 'customer', [
        'reseller.product.view',
        'serviceprovider.product.view',
        'master.product.view',
      ]);

      handleProductPrivilege(newState, 'reseller', [
        'serviceprovider.product.view',
        'master.product.view',
      ]);

      handleProductPrivilege(newState, 'serviceprovider', [
        'master.product.view',
      ]);
    }

    togglePrivilegesForRole(newState, e.target.checked, isNotEmptyRole, index);
    return newState;
  });
};


/* --------------------------------------------------- */

const handlePrivileges = (e, index1, index2) => {
  setPermissionList((prev) => {
    const newState = { ...prev };
    const priv = newState.privileges[index1].privileges[index2];
    priv.isAssigned = e.target.checked;

    updateBindedPrivileges(newState, index1, index2, e.target.checked);
    handleRoleBasedPrivileges(newState, priv.value);
    handleProductRoleDependencies(newState, priv.value);

    updateAllManagementState(newState, index1, e.target.checked);
    return newState;
  });
};

/* ---------------- Helper Functions for handlePrivileges ---------------- */

/** Ensures view privilege is auto-selected when create/update/delete is checked */
function updateBindedPrivileges(state, index1, index2, isChecked) {
  const privileges = state.privileges[index1].privileges;
  const name = privileges[index2].displayName.toLowerCase();

  if (/(update|create|delete)/.test(name) && isChecked) {
    privileges.forEach(
      (item) => item.displayName.toLowerCase().includes('view') && (item.isAssigned = true)
    );
  }

  if (name.includes('view') && !isChecked) {
    privileges.forEach((item) => {
      if (/(update|create|delete)/.test(item.displayName.toLowerCase())) {
        item.isAssigned = false;
      }
    });

    if (privileges.length > 1) {
      setAllManagement((prev) => {
        prev[index1] = false;
        return prev;
      });
    }
  }
}

/** Handles assigning related company privileges (ServiceProvider, Reseller, Customer) */
function handleRoleBasedPrivileges(state, value) {
  const val = value.toLowerCase();
  if (val.includes('serviceprovider'))
    assignViewPrivileges(state, 'ServiceProvider Company', 'serviceprovider');
  if (val.includes('reseller')) assignViewPrivileges(state, 'Reseller Company', 'reseller');
  if (val.includes('customer')) assignViewPrivileges(state, 'Customer Company', 'customer');
}

/** Handles cross product-level privilege linking */
function handleProductRoleDependencies(state, value) {
  const val = value.toLowerCase();

  const mapping = {
    customer: ['reseller.product.view', 'serviceprovider.product.view', 'master.product.view'],
    reseller: ['serviceprovider.product.view', 'master.product.view'],
    serviceprovider: ['master.product.view'],
  };

  Object.entries(mapping).forEach(([key, views]) => {
    if (val.includes(`${key}.product.create`) || val.includes(`${key}.product.update`)) {
      assignRelatedViews(state, views);
    }
  });
}

/** Update allManagement state based on total assigned items */
function updateAllManagementState(state, index1, isChecked) {
  const privileges = state.privileges[index1].privileges;
  const checkedCount = privileges.filter((p) => p.isAssigned).length;
  const allChecked = checkedCount === privileges.length;

  if ((allChecked && isChecked) || checkedCount === privileges.length - 1 && !isChecked) {
    setAllManagement((prevState) =>
      prevState.map((item, i) => (i === index1 ? !item : item))
    );
  }
}
  const checkSPCompanyView = (permission) => {
    let boolPermission = false
    const rolsSPFilter = permission.filter((rolChild, ind) => {
      if (rolChild.groupName.toLowerCase().includes('company')) {
        return rolChild.privileges
      }
    })
    rolsSPFilter.forEach((dat) => {
      if (dat.groupName.toLowerCase().includes('company')) {
        for (let i = 0; i < dat.privileges.length; i++) {
          if (
            dat.privileges[i].value.toLowerCase().includes('serviceprovider') &&
            dat.privileges[i].value.toLowerCase().includes('view')
          ) {
            boolPermission = dat.privileges.some((val) => val.isAssigned)
            break
          }
        }
      }
    })
    return boolPermission
  }
  const checkResellerCompanyView = (permission) => {
    let boolPermission = false
    const rolsSPFilter = permission.filter((rolChild, ind) => {
      if (rolChild.groupName.toLowerCase().includes('company')) {
        return rolChild.privileges
      }
    })
    rolsSPFilter.forEach((dat) => {
      if (dat.groupName.toLowerCase().includes('company')) {
        for (let i = 0; i < dat.privileges.length; i++) {
          if (
            dat.privileges[i].value.toLowerCase().includes('reseller') &&
            dat.privileges[i].value.toLowerCase().includes('view')
          ) {
            boolPermission = dat.privileges.some((val) => val.isAssigned)
            return boolPermission
          }
        }
      }
    })
    return boolPermission
  }
  const checkCustomerCompanyView = (permission) => {
    let boolPermission = false
    const rolsSPFilter = permission.filter((rolChild, ind) => {
      if (rolChild.groupName.toLowerCase().includes('company')) {
        return rolChild.privileges
      }
    })
    rolsSPFilter.forEach((dat) => {
      if (dat.groupName.toLowerCase().includes('company')) {
        for (let i = 0; i < dat.privileges.length; i++) {
          if (
            dat.privileges[i].value.toLowerCase().includes('customer') &&
            dat.privileges[i].value.toLowerCase().includes('view')
          ) {
            boolPermission = dat.privileges.some((val) => val.isAssigned)
            return boolPermission
          }
        }
      }
    })
    return boolPermission
  }
  const checkServiceSelectedBool = (permissions) => {
  const dependencyRules = [
    {
      source: ['customer.product.create', 'customer.product.update'],
      target: 'reseller.product.view',
      message: 'Please select View Service permission on Reseller Service Management',
    },
    {
      source: ['reseller.product.create', 'reseller.product.update'],
      target: 'serviceprovider.product.view',
      message: 'Please select View Service permission on Serviceprovider Service Management',
    },
    {
      source: ['serviceprovider.product.create', 'serviceprovider.product.update'],
      target: 'master.product.view',
      message: 'Please select View Service permission on Master Service Management',
    },
  ];

  /** Utility: Flatten all privileges into one array */
  const allPrivileges = permissions.flatMap((group) => group.privileges);

  /** Utility: Check if privilege exists and assigned */
  const hasPrivilegeAssigned = (searchValue) =>
    allPrivileges.some(
      (priv) =>
        priv.value.toLowerCase().includes(searchValue.toLowerCase()) &&
        priv.isAssigned
    );

  /** Validate each dependency rule */
  for (const { source, target, message } of dependencyRules) {
    const hasSourceAssigned = source.some((src) => hasPrivilegeAssigned(src));
    const hasTargetAssigned = hasPrivilegeAssigned(target);

    if (hasSourceAssigned && !hasTargetAssigned) {
      toast.showToast(message, 'error');
      return false;
    }
  }

  return true;
};

  useEffect(() => {
    if (props?.details) {
      getRoleByIdPrivilegesApi(props?.details?.roleId)
    }
  }, [])
  return (
    <Box role="presentation">
      {submitLoader ? <LoadingSection></LoadingSection> : ''}
      <List>
        <div style={{ padding: '0px 30px' }}>
          <form onSubmit={formik.handleSubmit}>
            <div style={{ paddingBottom: ' 100px' }}>
              <Grid container columnSpacing={4} rowSpacing={3}>
                <Grid item md={6} sm={6} xs={6}>
                  {requiredLabel('Role Name')}
                  <TextField
                    id="roleName"
                    name="roleName"
                    onChange={formik.handleChange}
                    value={formik.values.roleName}
                    fullWidth
                    InputProps={{
                      style: {
                        height: '35px',
                      },
                    }}
                  />
                  <div
                    style={{
                      color: 'red',
                      position: 'absolute',
                      marginBottom: '5px',
                    }}
                  >
                    {formik.errors.roleName && formik.errors.roleName}
                  </div>
                </Grid>
              </Grid>
              <h4>
                <div style={{ display: 'flex' }}>
                  <div>Choose Permissions</div>
                </div>
              </h4>

              <Grid
                item
                md={12}
                sm={12}
                xs={12}
                style={{
                  height: 'calc(90vh - 280px)',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                }}
              >
                {loader ? (
                  <div
                    style={{
                      padding: '5px 10px 0 20px',
                    }}
                  >
                    <SkeletonTableLoader></SkeletonTableLoader>
                  </div>
                ) : (
                  <>
                    {permissionList?.privileges?.map((rol, index1) => {
                      return <>
                        {rol.groupName.includes('Dashboard') ? (
                          ''
                        ) : (
                          <Grid key={index1 + 'grid'}>
                            <FormControlLabel
                              style={{
                                borderTop: '1px solid silver',
                                width: '100%',
                              }}
                              label={rol?.groupName.replace(
                                /ServiceProvider/g,
                                'Service Provider'
                              )}
                              key={index1 + 'formControl'}
                              control={
                                <Checkbox
                                  disabled={rol?.groupName.includes(
                                    'Company'
                                  )}
                                  key={index1 + 'checkbox'}
                                  indeterminate={
                                    rol.privileges.filter(
                                      (is) => is.isAssigned
                                    ).length != rol.privileges.length &&
                                    rol.privileges.filter(
                                      (is) => is.isAssigned
                                    ).length != 0
                                  }
                                  checked={
                                    rol.privileges.filter(
                                      (is) => is.isAssigned
                                    ).length == rol.privileges.length
                                  }
                                />
                              }
                              onChange={(event) =>
                                handleAllPrivileges(event, rol, index1)
                              }
                            />

                            <Box
                              key={index1 + '_' + rol.groupName + 'box'}
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                ml: 3,
                              }}
                            >
                              {rol?.privileges?.map((childRol, index2) => {
                              if(childRol.id == SERVICE_MANAGEMENT_CREATE_SERVICE_ID &&  commonState.currentCompanyDetails?.companyLevel ==
                                      COMPANY_LEVELS.customer && !commonState.currentCompanyDetails.directCustomer) return null //Should not allowed to use create service functionality for ReSeller Customer
                                return (
                                  <Box
                                    key={
                                      childRol.id +
                                      '_' +
                                      index1 +
                                      '_' +
                                      index2 +
                                      'box'
                                    }
                                  >
                                    <FormControlLabel
                                      key={
                                        childRol.id +
                                        '_' +
                                        index1 +
                                        '_' +
                                        index2
                                      }
                                      label={childRol?.displayName.replace(
                                        /ServiceProvider/g,
                                        'Service Provider'
                                      )}
                                      name={childRol.id}
                                      control={
                                        <Checkbox
                                          disabled={childRol?.value.includes(
                                            'company.view'
                                          )}
                                          key={
                                            childRol.id +
                                            '_' +
                                            index1 +
                                            '_' +
                                            index2 +
                                            'checkbox'
                                          }
                                          checked={childRol?.isAssigned}
                                          onChange={(event) =>
                                            handlePrivileges(
                                              event,
                                              index1,
                                              index2,
                                              // childRol
                                            )
                                          }
                                        />
                                      }
                                    />
                                  </Box>
                                );
                              })}
                            </Box>
                          </Grid>
                        )}
                      </>;
                    })}
                  </>
                )}
              </Grid>
            </div>

            <Box
              style={{
                position: 'fixed',
                bottom: '0px',
                paddingTop: '30px',
                paddingBottom: '30px',
                background: 'white',
                display: 'flex',
              }}
            >
              <Button
                disabled={!formik.isValid}
                type="submit"
                variant="contained"
                color="primary"
                disableElevation
                size="large"
              >
                Update Role
              </Button>
              <div style={{ marginLeft: '20px' }}>
                <Button
                  variant="outlined"
                  onClick={() =>
                    props.toggleDrawer('right', false, '', '', false)
                  }
                  disableElevation
                  size="large"
                >
                  Cancel
                </Button>
              </div>
            </Box>
          </form>
        </div>
      </List>
    </Box>
  );
}

export default EditRole
